export enum StatusCellClasses {
  RED = 'red',
  GREEN = 'green',
  PRIMARY = 'primary',
  DARK = 'dark',
  SECONDARY = 'secondary',
}
